import {Col, FormGroup, Label, Row} from "reactstrap";
import {I18n} from "../../I18n/components/promoter";
import CompanySelect from "../Company/CompanySelect";
import React from "react";

const CompanySelectRow = props => {
    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <Label for="companies">
                        {I18n[props.lang].company}
                    </Label>
                    <CompanySelect
                        lang={props.lang}
                        companyId={props.companyId}
                        companies={props.companies}
                        onCompanyChange={props.onCompanyChange}
                        required={props.required}
                    />
                    {props.validator.showErrors('companyId')}
                </FormGroup>
            </Col>
        </Row>
    )
}

export default CompanySelectRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/CompanySelectRow.js